import React from 'react';
import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../pages/UsersArea/Admin/Sidebar/AdminSidebar';

const AdminLayout = () => {
  const bg = useColorModeValue('gray.50', 'gray.900');

  return (
    <Flex minH="100vh" bg={bg}>
      <AdminSidebar />
      
      <Box
        flex="1"
        ml={{ base: 0, lg: "250px" }}
        transition="margin-left 0.3s"
      >
        <Outlet />
      </Box>
    </Flex>
  );
};

export default AdminLayout;
